import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authProviders, AuthGuard } from '../../auth.guard';
import { ModuleWithProviders } from '@angular/core';
import { SearchPatientComponent } from '../consultation/search-patient/search-patient.component';
import { WaitingRoomComponent } from '../consultation/waiting-room/waiting-room.component';
import { PreviousWaitingRoomComponent } from '../consultation/waiting-room/previous-waiting-room/previous-waiting-room.component';
import { CashSaleComponent } from '../consultation/cash-sale/cash-sale.component';
import { ResultSearchPatientComponent } from './result-search-patient/result-search-patient.component';

const consultationRoutes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: 'result-search-patient', component: ResultSearchPatientComponent },
      { path: 'search-patient', component: SearchPatientComponent },
      { path: 'waiting-room', component: WaitingRoomComponent },
      { path: 'previous-waiting-room', component: PreviousWaitingRoomComponent },
      { path: 'cash-sale', component: CashSaleComponent },
      { path: 'cash-sale/invoice/:patientId/:isFromHistory', component: CashSaleComponent },
      { path: 'cash-sale/:id/:patientId', component: CashSaleComponent },
      { path: 'cash-sale/:id/:patientId/:isFromHistory', component: CashSaleComponent },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(consultationRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class ConsultationRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/consultation.routing.ts